import axios, { AxiosPromise } from "axios";
import {
    GetDeliveryPromiseOfferRankingRequest,
    GetDeliveryPromiseOfferRankingResponse,
    GetWaitlistSubscriptionStatusRequest,
    GetWaitlistSubscriptionStatusResponse,
    SubscribeToWaitlistRequest
} from "./types";
import { Urls } from "./urls";

// Get variation delivery promise and offer ranking using same ajax end point.
const getDeliveryPromiseByState = (request: GetDeliveryPromiseOfferRankingRequest): AxiosPromise<GetDeliveryPromiseOfferRankingResponse> => {
    return axios.get(Urls.GET_DELIVERY_PROMISES_OFFER_RANKING(request));
}

const getWaitlistSubscriptionStatus = (request: GetWaitlistSubscriptionStatusRequest): AxiosPromise<GetWaitlistSubscriptionStatusResponse> => {
    return axios.get(Urls.GET_WAITLIST_SUBSCRIPTION_STATUS(request));
}


const subscribeToWaitlist = (request: SubscribeToWaitlistRequest): AxiosPromise<void> => {
    // Need to change to POST request in future.
    // See https://sim.amazon.com/issues/KATARA-PX-413
    return axios.get(Urls.SUBSCRIBE_TO_WAITLIST(request));
}

export const api = {
    getDeliveryPromiseByState,
    getWaitlistSubscriptionStatus,
    subscribeToWaitlist,
};